import SearchInput from '../../../components/ui/SearchInput';
import Select from '../../../components/ui/Select';
import {
    INTEGRATION_EXPIRING_FILTERS,
    INTEGRATION_STATUS_FILTERS,
    INTEGRATION_TYPE_FILTERS,
} from '../../../domain/superadmin/integrationFilters';
import type { AdminIntegrationFilters } from '../hooks/useAdminIntegrations';

type Props = {
    filters: AdminIntegrationFilters;
    search: string;
    onSearch: (value: string) => void;
    onChange: (patch: Partial<AdminIntegrationFilters>) => void;
};

const ALL = { value: '', label: 'Todos' };

function withAll(
    options: { value: string; label: string }[],
): { value: string; label: string }[] {
    return [ALL, ...options];
}

export function IntegrationsFilters({ filters, search, onSearch, onChange }: Props) {
    return (
        <section
            aria-label="Filtros e busca"
            className="mb-s4 flex flex-col gap-s3 lg:flex-row lg:items-end"
        >
            <div className="grid flex-1 grid-cols-1 gap-s3 sm:grid-cols-3">
                <Select
                    label="Tipo"
                    selectSize="sm"
                    value={filters.type}
                    options={withAll(INTEGRATION_TYPE_FILTERS)}
                    onChange={(e) => onChange({ type: e.target.value })}
                />
                <Select
                    label="Status"
                    selectSize="sm"
                    value={filters.status}
                    options={withAll(INTEGRATION_STATUS_FILTERS)}
                    onChange={(e) => onChange({ status: e.target.value })}
                />
                <Select
                    label="Expiração"
                    selectSize="sm"
                    value={filters.expiringSoon}
                    options={withAll(INTEGRATION_EXPIRING_FILTERS)}
                    onChange={(e) => onChange({ expiringSoon: e.target.value })}
                />
            </div>

            <div className="w-full lg:w-72">
                <SearchInput
                    value={search}
                    onChange={onSearch}
                    placeholder="Buscar por empresa, nome, account..."
                />
            </div>
        </section>
    );
}
